<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
            @click="toggleHeader"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab></settings-tab>
      <div class="row">
        <others-sidebar></others-sidebar>
        <div class="col-xl-9">
          <div class="card">
            <div class="card-header px-0 mx-3">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Clear Cache</h4>
              </div>
            </div>
            <div class="card-body pb-0">
              <div class="cache-content">
                <p class="fs-14 text-dark mb-3">
                  <span class="me-2">
                    <i class="ti ti-info-circle text-danger"></i>
                  </span>
                  Clearing the cache may improve performance but will remove
                  temporary files, stored preferences, and cached data from
                  websites and applications.
                </p>
                <div class="d-flex align-items-center justify-content-end mb-3">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-outline-primary me-3"
                  >
                    Cancel
                  </a>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="handleClear"
                    :disabled="loading"
                  >
                    <span
                      v-if="loading"
                      class="spinner-border spinner-border-sm me-1"
                    ></span>
                    Clear Cache
                  </button>
                </div>
                <p v-if="loading" class="text-muted mb-3">
                  Clearing application cache...
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <clear-modal></clear-modal>
</template>

<script setup>
import { computed } from "vue";
import { useCacheStore } from "@/stores/settings/cache.store";

const title = "Settings";
const text = "Administration";
const text1 = "Settings";

const cacheStore = useCacheStore();
const loading = computed(() => cacheStore.loading);

function toggleHeader() {
  document.getElementById("collapse-header").classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function handleClear() {
  await cacheStore.clearCache();
}
</script>


